<main class="booking-info">
  <div class="grid-2col gap-1">
    <div>
      <h1 class="booking-info__title">Booking Details</h1>
      <ul class="booking-info__container">
        <h5 class="booking-info__title-small">Request Summary</h5>
        <li class="booking-info__request">
          <img class="booking-info__icon" src="../../../../assets/img/icons/check-in.svg" alt="">
          <div class="flex jc-sb w-100">
            <span>Check-in</span>
            <span class="request-data">{{getDate(bookingRequest.fromdate)}}</span>
          </div>
        </li>
        <li class="booking-info__request">
          <img class="booking-info__icon" src="../../../../assets/img/icons/check-out.svg" alt="">
          <div class="flex jc-sb w-100">
            <span>Check-out</span>
            <span class="request-data">{{getDate(bookingRequest.todate)}}</span>
          </div>
        </li>
        <li class="booking-info__request">
          <img class="booking-info__icon" src="../../../../assets/img/icons/adult.svg" alt="">
          <div class="flex jc-sb w-100">
            <span>Adult{{(getAdult()!=1)?'s':''}}</span>
            <span class="request-data">{{getAdult()}}</span>
          </div>
        </li>
        <li class="booking-info__request">
          <img class="booking-info__icon" src="../../../../assets/img/icons/child.svg" alt="">
          <div class="flex jc-sb w-100">
            <span>{{(getChildrens()!=1)?'Children':'Child'}}</span>
            <span class="request-data">{{getChildrens()}}</span>
          </div>
        </li>
        <li class="booking-info__request">
          <img class="booking-info__icon" src="../../../../assets/img/icons/nights.svg" alt="">
          <div class="flex jc-sb w-100">
            <span>Night(s)</span>
            <span class="request-data">{{getNightsSafari(bookingRequest.fromdate, bookingRequest.todate)}}</span>
          </div>
        </li>
      </ul>
      <div *ngIf="offerNote" class="booking-note__container">
        <h4 class="booking-note__title">The host's message!</h4>
        <p *ngIf="offerNote" class="booking-note__text">{{ offerNote }}</p>
      </div>
      <div *ngIf="finalWishes && finalWishes.size > 0" class="booking-info__container">
        <div class="flex ai-base jc-sb">
          <h5 class="booking-info__title-small">Wishes your host can fulfill</h5>
          <span *ngIf="finalWishes" class="wishes__count">{{ totalSatisfied }} / {{ finalWishes.size }}</span>
        </div>
        <div class="wishes-container flex jc-sb" *ngFor="let wish of finalWishes | keyvalue">
          <span>{{ wish.key }}</span>
          <svg role="img" title="Star icon representing a wish" [ngStyle]="wish.value ? {'fill':'#2C6DA9'} : {'stroke':'#2C6DA9'}" xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none">
            <path
              d="M9.258 13.16 9 13.002l-.258.156-3.623 2.187.956-4.12.068-.294-.228-.197L2.72 7.962l4.215-.364.3-.026.118-.277L9 3.415l1.647 3.88.118.277.3.026 4.214.363-3.201 2.774-.228.197.068.294.96 4.118-3.62-2.185Z"
            />
          </svg>
        </div>
      </div>
      <!-- <div>
        <span *ngFor="let wish of finalWishes | keyvalue">
          {{ wish.key }} {{ wish.value }}
        </span>
      </div> -->
      <div class="booking-info__container">
        <div class="hotelPolicies">
          <h5 class="booking-info__title-small">Property Policies</h5>
          <!-- <a *ngIf="!isDetailsVisible() && !isVoucher()" class="booking-info__toggle-show" (click)="showDetails()">Show
            Details</a>
          <a *ngIf="isDetailsVisible() && !isVoucher()" class="booking-info__toggle-hide" (click)="showDetails()">Hide
            Details</a> -->
          <div id="policies-text">
            <div *ngIf="checkinInfo">
              <div class="flex jc-sb">
                <span>Check-in</span>
                <span class="pricing-data">{{checkinInfo.checkInTimeFrom}} - {{checkinInfo.checkInTimeUntil}}</span>
              </div>
              <div class="flex jc-sb">
                <span>Check-out</span>
                <span class="pricing-data">{{checkinInfo.checkOutTimeFrom}} - {{checkinInfo.checkOutTimeUntil}}</span>
              </div>
            </div>
            <div *ngIf="pricingPolicy">
              <span>Cancellation / prepayment</span>
              <span>Cancellation Policy:</span>
              <span>Free Cancellation</span>
              <span>{{pricingPolicy.alternativeTitle}}</span>
              <span *ngFor="let text of pricingPolicy.cancelationPrepayment">
                {{text}}
              </span>
            </div>
            <div class="flex jc-sb">
              <span>Pets</span>
              <span class="pricing-data">Not Allowed</span>
            </div>
          </div>
        </div>
        <div *ngIf="cards" (click)="cardsVisible = !cardsVisible">
          <div class="flex jc-sb">
            <span>Cards Accepted</span>
            <span class="--bold">
              Show more
              <svg class="arrow-down" width="8" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.126 1.971L6.08 6.41l-4.954 4.562" stroke="#042e4a" stroke-width="2" />
              </svg>
            </span>
          </div>
          <div *ngIf="cardsVisible" class="flex gap-05 mt-3">
            <span class="booking-info__cards" *ngFor="let card of cards"
              [ngStyle]="{'background-image': 'url(data:image/png;base64,' + card.creditCards.image + ')'}">
            </span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h1 class="booking-info__title">Price Breakdown</h1>
      <div class="grid-1col-a gap-1">
        <div *ngFor="let room of roomsToShow; let roomi = index" class="booking-info__container mb-0">
          <h5 *ngIf="room" class="booking-info__title-small">{{room[0].name}}</h5>
          <div class="booking-info__section flex jc-sb">
            <span>{{ getNightsSafari(bookingRequest.fromdate, bookingRequest.todate) }}
              Nights for {{ room[0].selectedRooms }} Room(s)</span>
            <span class="pricing-data">{{ bookingRequest.totalprice - getExtraCost(room[0]) }}€</span>
          </div>
          <div class="booking-info__section" *ngIf="room[0].selectedExtrasToShow.length > 0">
            <h4 class="booking-info__subtitle">Vervendo Experiences</h4>
            <ul *ngFor="let extra of room[0].selectedExtrasToShow" class="booking-info__exp-list">
              <li class="flex jc-sb">
                <span>{{extra.title}}
                  <span class="pricing-data" *ngIf="extra.quantity > 1">x{{extra.quantity}}</span>
                </span>
                <span class="pricing-data" *ngIf="extra.price === 0">FREE</span>
                <span class="pricing-data" *ngIf="extra.price > 0">{{extra.price}}€</span>
              </li>
            </ul>
            <div class="booking-info__pricing flex jc-sb">
              <span>Experiences Total</span>
              <span class="pricing-data">{{getExtraCost(room[0])}}€</span>
            </div>
          </div>
          <div class="booking-info__section">
            <h4 class="booking-info__subtitle">Room Policies</h4>
            <div class="booking-info__pricing flex jc-sb">
              <span>Pricing</span>
              <span class="pricing-data">{{ room[0].pricingPolicy.depositPercent }}% Deposit</span>
            </div>
            <div class="booking-info__pricing flex jc-sb">
              <span>Cancellation</span>
              <span class="pricing-data" *ngIf="room[0].cancellationPolicy.freeCancellation">Free Cancellation</span>
              <span class="pricing-data">{{ room[0].cancellationPolicy.noShow }}% No-show</span>
            </div>
          </div>
        </div>
        <div class="booking-info__container-total">
          <h5 class="booking-info__title-total" *ngIf="hotelInfo">{{hotelInfo.title}}</h5>
          <div class="total-price-section">
            <div class="flex jc-sb">
              <span class="booking-info__grand-total">Grand Total</span>
              <span class="booking-info__grand-total">{{bookingRequest.totalprice}}€</span>
            </div>
            <div class="booking-info__caption-total">(including taxes and fees)</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</main>

<div class="booking-info__btn-container flex jc-c">
  <button *ngIf="!isVoucher()" (click)="bookNow()" class="booking-info__btn">Confirm Booking</button>
</div>